import { Grid, Stack, styled, Typography } from "@mui/material";
import FlexRowAlign from "components/flexbox/FlexRowAlign";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const Section = styled("section")(({ theme }) => ({}));

export const Section3 = () => {
  const innerHeight = window.innerHeight;
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: false,
    margin: `${-innerHeight / 4}px`,
  });

  return (
    <Section
      ref={ref}
      sx={{
        position: "relative",
        scrollSnapAlign: "center",
      }}
    >
      <Stack
        sx={{ height: "100%", width: "100%", px: { xs: 0, md: 20 } }}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Grid container rowSpacing={5} columnSpacing={5}>
          <Grid item xs={12}>
            <motion.div
              initial={{
                transform: ` scaleY(0)`,
                opacity: 0,
              }}
              animate={{
                transform: ` scaleY(${isInView ? 1 : 0
                  })`,
                opacity: isInView ? 1 : 0,
              }}
              transition={{
                type: "spring",
                stiffness: 700,
                damping: 30,
                delay: 0.2,
              }}
            >
              <Typography
                sx={{
                  textTransform: "uppercase",
                  fontWeight: 700,
                  fontSize: { xs: 18, sm: 24, lg: 36 },
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                A perpetual dex designed to help traders earn more
              </Typography>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{
                y: 20,
                opacity: 0,
              }}
              animate={{ y: isInView ? 0 : 20, opacity: isInView ? 1 : 0 }}
              transition={{ duration: 0.2, delay: 0.4 }}
            >
              <FlexRowAlign justifyContent={"flex-start"}>
                <img src="static/svg/list-style.svg" alt="list" />
                <Stack>
                  <Typography
                    sx={{
                      textTransform: "uppercase",
                      fontSize: { xs: "14px", md: "24px", lg: "32px" },
                    }}
                  >
                    NATIVE YIELD
                  </Typography>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: "9px",
                    }}
                  >
                    Yield as a primitive unlocks new business models for
                    perpetual DEXs. USDC deposited to Flaex automatically earns
                    yield.
                  </Typography>
                </Stack>
              </FlexRowAlign>
              <Typography
                sx={{
                  paddingLeft: "1.5rem",
                  display: { xs: "none", md: "block" },
                }}
              >
                Yield as a primitive unlocks new business models for perpetual
                DEXs. USDC deposited to Flaex automatically earns yield.
              </Typography>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{
                y: 20,
                opacity: 0,
              }}
              animate={{ y: isInView ? 0 : 20, opacity: isInView ? 1 : 0 }}
              transition={{ duration: 0.2, delay: 0.5 }}
            >
              <FlexRowAlign justifyContent={"flex-start"}>
                <img src="static/svg/list-style.svg" alt="list" />
                <Stack>
                  <Typography
                    sx={{
                      textTransform: "uppercase",
                      fontSize: { xs: "14px", md: "24px", lg: "32px" },
                    }}
                  >
                    FEE REVENUE SHARING
                  </Typography>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: "9px",
                    }}
                  >
                    Flaex gives net fee revenue back to capital providers
                    programmatically. The higher the trading volume, the higher
                    the revenue for capital providers.
                  </Typography>
                </Stack>
              </FlexRowAlign>
              <Typography
                sx={{
                  paddingLeft: "1.5rem",
                  display: { xs: "none", md: "block" },
                }}
              >
                Flaex gives net fee revenue back to capital providers
                programmatically. The higher the trading volume, the higher the
                revenue for capital providers.
              </Typography>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{
                y: 20,
                opacity: 0,
              }}
              animate={{ y: isInView ? 0 : 20, opacity: isInView ? 1 : 0 }}
              transition={{ duration: 0.2, delay: 0.6 }}
            >
              <FlexRowAlign justifyContent={"flex-start"}>
                <img src="static/svg/list-style.svg" alt="list" />
                <Stack>
                  <Typography
                    sx={{
                      textTransform: "uppercase",
                      fontSize: { xs: "14px", md: "24px", lg: "32px" },
                    }}
                  >
                    GASLESS
                  </Typography>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: "9px",
                    }}
                  >
                    The Flaex protocol is designed to execute trading orders
                    without gas fees. This way, traders can focus solely on
                    trading, just as they do on CEXs.
                  </Typography>
                </Stack>
              </FlexRowAlign>
              <Typography
                sx={{
                  paddingLeft: "1.5rem",
                  display: { xs: "none", md: "block" },
                }}
              >
                The Flaex protocol is designed to execute trading orders without
                gas fees. This way, traders can focus solely on trading, just as
                they do on CEXs.
              </Typography>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{
                y: 20,
                opacity: 0,
              }}
              animate={{ y: isInView ? 0 : 20, opacity: isInView ? 1 : 0 }}
              transition={{ duration: 0.2, delay: 0.7 }}
            >
              <FlexRowAlign justifyContent={"flex-start"}>
                <img src="static/svg/list-style.svg" alt="list" />
                <Stack>
                  <Typography
                    sx={{
                      textTransform: "uppercase",
                      fontSize: { xs: "14px", md: "24px", lg: "32px" },
                    }}
                  >
                    AIRDROP
                  </Typography>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: "9px",
                    }}
                  >
                    Not just native yield, and not just token airdrops. Flaex
                    users have numerous opportunities to earn even more.
                  </Typography>
                </Stack>
              </FlexRowAlign>
              <Typography
                sx={{
                  paddingLeft: "1.5rem",
                  display: { xs: "none", md: "block" },
                }}
              >
                Not just native yield, and not just token airdrops. Flaex users
                have numerous opportunities to earn even more.
              </Typography>
            </motion.div>
          </Grid>
        </Grid>
      </Stack>
    </Section>
  );
};
